module.exports = __webpack_public_path__ + "img/boy_bow.c3160515.svg";